import { createFileRoute } from '@tanstack/react-router'
import { GuestsPage } from '@/features/guests/guests-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/guests')({
  component: GuestsRoute,
})

function GuestsRoute() {
  const { workspaceSlug } = Route.useParams()

  return <GuestsPage workspaceSlug={workspaceSlug} />
}
